import React from 'react';

// Components
import { Spinner } from 'react-bootstrap';

// Styles
import styles from './Loader.module.scss';

const Loader = () => {
  return (
    <div className={styles.loader}>
      <Spinner animation="border" />
    </div>
  );
};

export default Loader;
